<script setup>
import Popup from './popup.vue';
import { $vfm, VueFinalModal, ModalsContainer } from 'vue-final-modal';
</script>

<script>
export default {
  components: {
      Popup,
   },
  data: () => ({
    importpopupshow: false,
    tableName:"",
    viewPortId: '',
    selectedCRMTemplate: '',
    crmList: []
  }),
  mounted() {
  },
  computed:{
  },
  methods: {
      getCrmInfo : function(viewport) {
        let bpmnComponentTipId = '_FF00321822120916427824957001562784_';

        var client = window.botStore.getClientByViewPort(viewport);
        console.log("main home page client",client);

        let GrantPath = JSON.parse(client.ClientContext);
        let GrantPE = GrantPath.GrantPE;
        let currentContext = JSON.parse(client.CurrentContext);
        let requestContext = currentContext;
        let LocationContext = JSON.parse(client.LocationContext);

        let params = {
           componentId : bpmnComponentTipId,
           command : "getCrmList",
           data : requestContext,
           Type : 'BotApi'
         };
         this.crmList =[];
         let defaultcrmVal = {};
         defaultcrmVal.value = "_FFFFFFFFFFFFFF00001668203009117626_";
         defaultcrmVal.text =  "Simplia CRM";
         this.crmList.push(defaultcrmVal);

         window.BotServices.callComponent(params, (err, result) => {
           if(result) {
             console.log("===result crmList getComponents===",result);
             result.forEach((crm) => {
                 let crmVal = {};
                 crmVal.value = crm.GrantRightID;
                 crmVal.text =  crm.GrantRightDN;
                 this.crmList.push(crmVal);
             });
             console.log("crmList",this.crmList);
           }
         });
      },
    saveImportTable: function() {
      console.log("got table name to import ",this.tableName,"======",this.selectedCRMTemplate);
      let viewport = this.viewPortId;

      this.importpopupshow = false;
      let bpmnComponentTipId = '_FF00321822120916427824957001562784_';

      var client = window.botStore.getClientByViewPort(viewport);
      console.log("Import table popup client",client);

      let GrantPath = JSON.parse(client.ClientContext);
      let GrantPE = GrantPath.GrantPE;
      let currentContext = JSON.parse(client.CurrentContext);
      let requestContext = currentContext;
      let LocationContext = JSON.parse(client.LocationContext);

      requestContext.ImportTableName = this.tableName;
      requestContext.CRMTemplateId = this.selectedCRMTemplate;
      requestContext.LocationContext = LocationContext;
      requestContext.ProcessTemplateId = "_FFFFFFFFFFFFFF00001669209873678382_";
      console.log("Import table request",requestContext);

      let params = {
         componentId : bpmnComponentTipId,
         command : "importTable",
         data : requestContext,
         Type : 'BotApi'
       };

       window.BotServices.callComponent(params, (err, result) => {
         if(result) {
           console.log("===result importTable ===",result);
         }
       });
    },
    showPopUp : function(popObj) {
      console.log("====show pop up===="+this.importpopupshow);
      this.importpopupshow = true;
      console.log("====show pop up====",popObj);
      this.viewPortId = popObj.viewport;
      this.getCrmInfo(popObj.viewport);
    }
  }
}
</script>

<template>
<v-button style="display:none;" @click="show = true">Open modal</v-button>
<Popup v-model="importpopupshow" >
  <template v-slot:title>Import Table</template>
  <template v-slot:content>
  <form class="formbox" >
    <div class="form-group" style="display:flex;">
      <span class="label-text">Table Name&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
      <input type="text" name="tableName" id="tableName" class="form-dropdown" v-model="tableName"/>
    </div>
    <div class="form-group" style="display:flex;margin-top:5px;">
      <span class="label-text">Subject Template</span>
      <select name="subjectTemplate" id="subjectTemplate" class="form-dropdown" v-model="selectedCRMTemplate">
          <option value="">Select Template</option>
          <option v-for="crm in crmList" v-bind:value=crm.value>{{ crm.text }}</option>
      </select>
    </div>
  </form>
  </template>
  <template v-slot:action>
     <button id="btn-submit" type="button" class="ButtonText" @click="saveImportTable">Submit</button>
  </template>
</Popup>
</template>

<style>
.label-text {
    padding: 0 50px;
    font-size: inherit;
    overflow: hidden;
    /*text-overflow: ellipsis;*/
    white-space: nowrap;
    font-family: Roboto,Arial,Tahoma,Verdana,sans-serif!important;
}
.input-text {
  background-color: white;
  border: 1px solid lightgray;
  width: 100%;
  display: block;
}
.ButtonText{
    margin-left: 145px;
    height: 25px;
    background-color: #0072c5;
    color: #fff;
    white-space: nowrap;
    align-items: center;
    font-family: Roboto,Arial,Tahoma,Verdana,sans-serif!important;
    width:100%;
}

formbox{
  max-width:460px;
  margin:auto;
  margin-top:35px;
  border:0px solid #2f2f2f;
  padding:24px;
  border-radius:4px;
}
#btn-submit{
  width:100%;
}
</style>
